import "App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "layout";
import ModalManager from "modal";
import { useEffect, useState } from "react";
import { api } from "services";
import { RootState } from "reducer/store";
import { CustomerInterface } from "interfaces";
import { bulkSetUserInfo, clearUserInfo } from "reducer/user.slice";
import { clearAuthInfos } from "reducer/wallet.slice";
import { useDispatch, useSelector } from "react-redux";

function App() {
  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      dispatch(clearUserInfo());
      dispatch(clearAuthInfos());
      sessionStorage.clear();
      localStorage.clear();
    }
  }, [])

  useEffect(() => {
    api.getSSOMeta().then(() => {
      setIsLoading(false);
    }).catch(() => {
      setTimeout(() => {
        setTrigger(!trigger)
      }, 5000)
    });
  }, [trigger])

  async function loadUserInfo() {
    let token = sessionStorage.getItem("token");
    if (!token) {
      return;
    }
    let rs = await api.post("/scholar/get-customer-info", {});
    dispatch(bulkSetUserInfo({ ...rs }));
  }

  useEffect(() => {
    window.addEventListener("focus", loadUserInfo);
    return () => {
      window.removeEventListener("focus", loadUserInfo);
    }
  }, [user?.[CustomerInterface.id]])

  if (isLoading) return <></>

  return (
    <div className="App">
      <Router basename="/">
        <ModalManager />
        <Routes>
          <Route path="/*" element={<Layout />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
